import {MatTableDataSource} from '@angular/material/table';
import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth.service';
import { map, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { RouteService } from 'src/app/shared/services/route.service';

export interface curso{
  cantVentas: number;
  categoria: string;
  empresaNombre: string;
  empresaId: string;
  fechaCreacion: any;
  instructorId: string;
  instructorNombre: string;
  porcentajeDescuento: number;
  precioFinal: number;
  precioOriginal: number;
  publicado: boolean;
  titulo: string;
  id: string;
  }


@Component({
  selector: 'lista-cursos',
  templateUrl: './lista-cursos.component.html',
  styleUrls: ['./lista-cursos.component.css']
})

export class ListaCursosComponent  {

  constructor(
    public authService: AuthService,
    public afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private storage: AngularFireStorage,
    private router: Router,
    public routeService: RouteService,
  ) { }

  array: curso[];


  ngOnInit(){
    this.afs.doc("global/indiceCursos").get().subscribe(snap => {
      const cursos = snap.data();
      let arr = []
      Object.keys(cursos).map(function(key) {
        arr.push(cursos[key])
        return arr;
      });
      const length = arr.length
      let arreglo = []
      for (let index = 0; index < length; index++) {
        const curso: curso = {
          cantVentas: arr[index].cantVentas,
          categoria: arr[index].categoria,
          empresaNombre: arr[index].empresaNombre,
          empresaId: arr[index].empresaId,
          fechaCreacion: arr[index].fechaCreacion,
          instructorId: arr[index].instructorId,
          instructorNombre: arr[index].instructorNombre,
          porcentajeDescuento: arr[index].porcentajeDescuento,
          precioFinal: arr[index].precioFinal,
          precioOriginal: arr[index].precioOriginal,
          publicado: arr[index].publicado,
          titulo: arr[index].titulo,
          id: arr[index].id,
        }
        arreglo.push(curso)
      }
      this.array = arreglo
      this.array.sort((a, b) => a.titulo.localeCompare(b.titulo));
      this.array.sort((a, b) => a.instructorNombre.localeCompare(b.instructorNombre));
      console.log(arreglo)
    })
  }

}